@let t = text();

<div class="jn-panel" data-test-id="just-now-panel">
  <header class="jn-panel__header">
    <h3 class="jn-panel__title">
      <i class="fas fa-{{ titleIcon }}" aria-hidden="true"></i>
      {{ title }}
    </h3>
    @if (active() && ichingIconsVisible() && ichingDayTarget()) {
      <!-- Classic I Ching: hexagram van dit moment (zon, maan, dagteller). -->
      <button
        type="button"
        class="jn-panel__iching"
        data-test-id="just-now-iching"
        [title]="t.ichingNow"
        [attr.aria-label]="t.ichingNow"
        (click)="openIChingDay($event)"
      >
        <i class="fa-regular fa-scroll-old" aria-hidden="true"></i>
      </button>
    }
    @if (active()) {
      <dl class="jn-panel__meta">
        <dt>{{ t.momentLabel }}</dt>
        <dd data-test-id="just-now-panel-moment">{{ momentText() }}</dd>
        @if (state.chartName()) {
          <dt>{{ t.chartLabel }}</dt>
          <dd data-test-id="just-now-panel-chart">{{ state.chartName() }}</dd>
        }
      </dl>
    }
  </header>

  @if (!active()) {
    <p class="jn-panel__hint" data-test-id="just-now-panel-inactive">{{ t.inactive }}</p>
  } @else {
    <p class="jn-panel__intro">{{ t.intro }}</p>

    <!-- Niet zelf center thema's van dit moment: klikbaar (center-info) + de
         transitactivaties die het center tijdelijk definiëren. Geen kaarten:
         die volgen in de secties. -->
    <section class="jn-panel__centers" data-test-id="just-now-panel-centers">
      <h4 class="jn-panel__subsection-title">{{ t.centersTitle }}</h4>
      @if (conditionedCenters().length === 0) {
        <p class="jn-panel__hint">{{ t.centersEmpty }}</p>
      }
      @for (item of conditionedCenters(); track item.center) {
        <hd-cycle-conditioned-center-block
          [center]="item.center"
          [label]="item.label"
          [text]="item.text"
          [causes]="item.causes"
          clickable
          (centerInfoRequested)="requestCenterInfo($event)"
          (gateInfoRequested)="requestGateInfo($event)"
        />
      }
    </section>

    @if (isEmpty()) {
      <p class="jn-panel__hint" data-test-id="just-now-panel-empty">{{ t.empty }}</p>
    }

    @for (section of sections(); track section.key) {
      <section class="jn-panel__section"
               [class.jn-panel__section--muted]="section.muted"
               [attr.data-section]="section.key">
        <!-- Sticky cheat-sheet-kop: de context (Persoonlijk, Educatief, …)
             blijft zichtbaar terwijl de kaarten eronder scrollen. -->
        <hd-cycle-section-header
          sticky
          [color]="section.color"
          [faIcon]="section.faIcon"
          [title]="section.title"
          [bringsLabel]="section.bringsLabel"
          [brings]="section.brings"
          [expanded]="isExpanded(section.key)"
          (toggle)="toggleSection(section.key)"
        />

        @if (isExpanded(section.key)) {
          <ul class="jn-panel__bullets">
            @for (bullet of section.bullets; track $index) {
              <li [innerHTML]="bullet"></li>
            }
          </ul>
        }

        @for (item of section.items; track item.key) {
          <article class="jn-panel__item" [attr.data-item]="item.key">
            @if (item.kind === 'channel') {
              <!-- Variant (electromagnetic / compromis / dominantie / vernieuwing)
                   als context-regel boven het kanaalblokje. -->
              <span class="jn-panel__variant" [style.--section-color]="section.color">{{ item.variantLabel }}</span>
              <hd-channel-list-item
                [channelKey]="item.channel.channelKey"
                [cycleGates]="item.channel.gates"
                [keynoteKey]="section.channelKeynoteKey"
                [accent]="section.channelAccent"
                expandable
                [expanded]="items.isExpanded(item.key)"
                (expandToggled)="items.toggle(item.key)"
                (gateInfoRequested)="requestGateInfo($event)"
                (channelInfoRequested)="requestChannelInfo($event)"
              />
            } @else {
              <hd-cycle-hanging-gate-block
                [hanging]="item.hanging"
                [color]="section.color"
                [faIcon]="section.faIcon"
                expandable
                [expanded]="items.isExpanded(item.key)"
                (expandToggled)="items.toggle(item.key)"
                (gateInfoRequested)="requestGateInfo($event)"
              />
            }

            <!-- Het neutrino-weer: per transitplaneet de I Tjing-lijnkaart (default open),
                 of een verwijzing wanneer dezelfde planeet al hoger een kaart kreeg. -->
            <hd-cycle-cards
              [slots]="item.cards"
              [visible]="items.isExpanded(item.key)"
              (referenceClicked)="scrollToCard($event)"
            />
          </article>
        }
      </section>
    }
  }
</div>
